import { render, staticRenderFns } from "./DeleteMaterialTagConfirmation.vue?vue&type=template&id=4007a4dd"
import script from "./DeleteMaterialTagConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteMaterialTagConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports